import { handleResponse, handleBlobResponse } from './handleResponse';
import { authHeader } from './authHeader';

export const HttpService = {
    post,
    postFile,
    downloadFile
};

function post(url, data) {
    url = process.env.PUBLIC_URL + url;

    return fetch(url, { method: 'POST', headers: authHeader(), body: JSON.stringify(data) }).then(handleResponse).catch(function (error) {
        const offlineMessage = ["offline", "Failed to fetch", "not connect"];
        const errorMessage = error || "";

        if (errorMessage) {
            var isOffline = false;
            offlineMessage.forEach(m => {
                if (errorMessage.toString().indexOf(m) !== -1) {
                    isOffline = true;
                }
            });

            return { offline: isOffline, error: true, message: errorMessage };
        }
        else {
            return { error: error.error || false };
        }
    });
}

function postFile(url, data) {
    url = process.env.PUBLIC_URL + url;

    return fetch(url, { method: 'POST', body: data }).then(handleResponse).catch(function (error) {
        if (error) {
            return { error: true }
        }
        else {
            return null;
        }
    });
}

function downloadFile(url, data) {
    url = process.env.PUBLIC_URL + url;

    return fetch(url, { method: 'POST', headers: authHeader(), body: JSON.stringify(data) }).then(handleBlobResponse).catch(function (error) {
        if (error) {
            return { error: true }
        }
        else {
            return null;
        }
    });
}
